<template>
  <div>
    <b-table
      :fields="fields"
      :items="(invoice && !addNewContractInvoice)
       ? ((invoiceItems && invoiceItems[0] && invoiceItems[0].instruments) ? invoiceItems[0].instruments : '') : instrumentItemsForEdit"
      responsive
      :tbody-tr-class="['tableRowClass']"
      class="mt-2"
      show-empty
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #row-details="row">
        <span v-if="row.item && row.item.responsible">
          {{$t('contact.comment')}}: {{ row.item.responsible }}
        </span>
      </template>



      <template #cell(product)="props">
        <div v-if="props.item && props.item.instrument && props.item.instrument.type && props.item.instrument.type.title">
          {{props.item.instrument.type.title}}
        </div>
      </template>


      <template #cell(instrument)="props">
        <div v-if="props.item && props.item.instrument && props.item.instrument.title">
          {{props.item.instrument.title}}
        </div>
      </template>


      <template #cell(count)="props">
        <div class="d-flex align-items-center justify-content-center">
          <b-form-group class="mb-0">
            <validation-provider
              #default="{ errors }"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
              >
                <b-form-input
                  :disabled="viewMode && ($route.query && $route.query.invoice != true)"
                  class="form-control-merge"
                  placeholder=""
                  min="0"
                  v-model="props.item.count"
                  @input="formatPrice(props.item.count, 'count', props.index)" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                />
                <b-input-group-append is-text>
                  <div v-if="props.item && (props.item.count || props.item.count == 0) && (props.item.quantity_sum || props.item.quantity_sum == 0)"
                  >
                    {{parseFloat(props.item.count) - parseFloat(props.item.quantity_sum)}}
                  </div>
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </div>
      </template>

      <template #cell(unit)="props">
        <div v-if="props.item && props.item.good && props.item.good.unity">
          {{props.item.good.unity}}
        </div>
      </template>

      <template #cell(price)="props">
        <div class="d-flex align-items-center justify-content-center"  v-if="!invoice">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
              >
                <b-form-input
                  :disabled="viewMode"
                  class="form-control-merge"
                  placeholder=""
                  v-model="props.item.price"
                  @input="formatPrice(props.item.price, 'price', props.index)" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
      </template>


      <template #cell(total_price)="props">
        <div class="d-flex align-items-center justify-content-center"  v-if="!invoice">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
              >
                <b-form-input
                  :disabled="viewMode"
                  class="form-control-merge"
                  placeholder=""
                  v-model="instrumentItemsForEdit[props.index].total_price"
                  @input="formatPrice(instrumentItemsForEdit[props.index].total_price, 'total_price', props.index)" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
      </template>


      <template #cell(actions)="data">
        <div>
          <b-button
            v-if="!viewMode"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            class="mt-50 mb-50"
            variant="danger"
            @click="deleteApp(data)"
          >
            <feather-icon
              icon="TrashIcon"
              size="16"
            />
          </b-button>
          
          <b-button size="sm" @click="data.toggleDetails" class="ml-50 mt-50 mb-50">
            <feather-icon
              icon="MessageSquareIcon"
              size="16"
            />
          </b-button>
        </div>
      </template>

    </b-table>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { BInputGroup, BFormGroup, BFormInput, BTable, BButton, BFormCheckbox, BInputGroupAppend, } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import areYouSure from '@/mixins/areYouSure'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BFormGroup,
    BFormInput,

    BTable,
    BButton,
    BFormCheckbox,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure],
  props: {
    invoice: {
      type: [Boolean, String],
      required: false
    }
  },
  data() {
    return {
      fields: [
        // {
        //   label: 'courses.type',
        //   key: 'type',
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          label: 'table.product_type',
          key: 'product',
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'model',
          key: 'instrument',
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'amount',
          key: 'count',
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'unit_of_measurement',
          key: 'unit',
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'price',
          key: 'price',
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'total_price',
          key: 'total_price',
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      total_price: [],
    }
  },
  computed: {
    ...mapGetters("agrements", ["GET_ONE_CONTRACT"]),
    ...mapState('agrements', ['materialAndInstrumentApplicationsForEdit', 'viewMode']),

    materialAndInstrumentApplicationsForEdit: {
      get: function () {
        return this.$store.state.agrements.materialAndInstrumentApplicationsForEdit;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS_FOR_EDIT', newValue)
      }
    },
    instrumentItemsForEdit: {
      get: function () {
        return this.$store.state.agrements.instrumentItemsForEdit;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INSTRUMENT_ITEMS_FOR_EDIT', newValue)
      }
    },
    invoiceItems: {
      get: function () {
        return this.$store.state.agrements.invoiceItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ITEMS', newValue)
      }
    },
    addNewContractInvoice: {
      get: function () {
        return this.$store.state.agrements.addNewContractInvoice;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_NEW_CONTRACT_INVOICE', newValue)
      }
    },
    refreshAgreement: {
      get: function () {
        return this.$store.state.agrements.refreshAgreement;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_REFRESH_AGREEMENT', newValue)
      }
    },
    
  },
  watch: {
    instrumentItemsForEdit(newValue){
      newValue.forEach((elem, index) => {
         elem.total_price = (parseFloat(elem.count.toString().replace(/,/g, '')) * parseFloat(elem.price.toString().replace(/,/g, ''))).toFixed(2)
        // this.formatPrice(this.total_price[index], 'total_price', index)
      })
    }
  }, 
  async mounted(){
    setTimeout(() => {
      if(this.invoice){
        this.fields.splice(4, 2)
        // this.fields.splice(3, 1)
      }
    }, 0)
  },
  methods: {
    ...mapActions('agrements', [
      'DELETE_CONTRACT_INSTRUMENTS',
      'DELETE_CONTRACT_INSTRUMENTS',
    ]),


    formatPrice(value, type, index) {
      if(value){
        let currency = value.toString().replace(/,/g, '');
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(currency);

        if(type == 'price'){
          this.instrumentItemsForEdit[index].price = currency
          this.instrumentItemsForEdit[index].total_price = (parseFloat(currency.toString().replace(/,/g, '')) * parseFloat(this.instrumentItemsForEdit[index].count.toString().replace(/,/g, ''))).toFixed(2)
          this.formatPrice(this.instrumentItemsForEdit[index].total_price, 'total_price', index)
        }else if(type == 'count'){
          this.instrumentItemsForEdit[index].count = currency
          this.instrumentItemsForEdit[index].total_price = (parseFloat(currency.toString().replace(/,/g, '')) * parseFloat(this.instrumentItemsForEdit[index].price.toString().replace(/,/g, ''))).toFixed(2)
        }else if(type == 'total_price'){
          this.instrumentItemsForEdit[index].total_price = currency
          this.instrumentItemsForEdit[index].price = (parseFloat(currency.toString().replace(/,/g, '')) / parseFloat(this.instrumentItemsForEdit[index].count.toString().replace(/,/g, ''))).toFixed(2)
        }

      }
      return 0;
    },



    deleteApp(data) {
      this.$_showAreYouSureModal().then(val => {

        if(val){

            if(data.item.id == null){
              this.instrumentItemsForEdit.forEach((elem, index) => {
                if(elem.instrument.id == data.item.instrument.id){
                  this.instrumentItemsForEdit.splice(index, 1);
                }
              })
              this.$store.commit('agrements/SET_INSTRUMENT_ITEMS_FOR_EDIT', this.instrumentItemsForEdit)

            }else{
              this.DELETE_CONTRACT_GOODS({id: data.item.id}).then(async () => {

                this.instrumentItemsForEdit.forEach((elem, index) => {
                  if(elem.instrument.id == data.item.instrument.id){
                    this.instrumentItemsForEdit.splice(index, 1);
                  }
                })
                this.$store.commit('agrements/SET_INSTRUMENT_ITEMS_FOR_EDIT', this.instrumentItemsForEdit)

                this.$_okToast()
              })
              .catch(err => {
                this.$_errToast(err)
              })
            }
        
          
          
          }
      })
    },
  },
}
</script>

<style lang="scss">
.dark-layout {
  #materials-table {
    border: 1px solid #3b4052;

    .tableRowClass {
      &:nth-child(2n) {
        background: rgba($color: #3b4052, $alpha: 0.7);
      }
    }
  }
}

#materials-table {
  border: 1px solid #f3f2f7;

  th {
    text-align: center;
  }

  .tableRowClass {
    &:nth-child(2n) {
      background: rgba($color: #f3f2f7, $alpha: 0.7);
    }

    td {
      padding: 10px 15px;
      text-align: center;
    }
  }


}
.input-group-text {
  background-color: #e9ecef !important;
}
</style>
